module.exports = __webpack_public_path__ + "img/contrast.d7bec2a8.svg";